import axios, { AxiosResponse } from "axios";
import environment from "../config";
import DepositData from "../entities/DepositData";
import axiosUtil from "../utils/helpers/axiosUtil";
import dal from "../middleware/DAL";

export async function GetDepositData(
  // watch it: when using this function with date values excepting get full deposits data,
  // you must pass second argument as undefined
  onlyMessageValues?: boolean | null,
  _dateTo?: string | null,
  _dateFrom?: string | null,
  fundCode?: number | null
) {
  try {
    const body = {
      fundCode: fundCode ? fundCode :null,
      dateTo: _dateTo?.length ? _dateTo : null,
      dateFrom: _dateFrom?.length ? _dateFrom : null,
    };
    const path: string = environment.BASE_URL + "MemberDetails/GetDepositData";
    const res: AxiosResponse<any> = await dal.post(path, body);
    if (axiosUtil.isSuccess(res) && res?.data?.depositData?.length) {
      const depositData = res.data.depositData;
      if (onlyMessageValues) {
        // const today = new Date();
        return depositData.filter(
          (deposit: any) =>
            !deposit.fullyAscribed &&
            (new Date(deposit.depositDate).getMonth() < new Date().getMonth() ||
              new Date(deposit.depositDate).getFullYear() <
                new Date().getFullYear())
        );
      }
      return depositData.sort((a: DepositData, b: DepositData) => {
        return (
          new Date(b.depositDate).valueOf() - new Date(a.depositDate).valueOf()
        );
      });
    }
    return [];
  } catch (err) {
    console.log(err);
  }
}
